export const publicOne =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCCNZa8N5Su41ESvsZMDkVspW0o1uVKbz0vxFZpMnub90ORr0OChD4d1npmB9nrlr7CqX1Xxs';
